import { ModalContext } from "@lib/context/ModalContext";
import { useFetch } from "@lib/hooks/useFetch";
import { IContactRespData } from "@lib/types";
import { API_INFO, getUpdateStorePersonnelFetcher } from "@lib/util/api";
import { createSignal, useContext } from "solid-js";
import { FetchStatusMessage } from "./fetchStatusComponents/FetchStatusMessage";
import { LoadingSpinner } from "./fetchStatusComponents/LoadingSpinner";

export function PersonnelContactForm() {
  const [, isLoading, fetchStatus, fetchData] = useFetch<IContactRespData>();
  const [errorMessage, setErrorMessage] = createSignal<string | null>(null);
  const { personnelUpdateInfo, setPersonnelUpdateInfo } = useContext(ModalContext)!;

  function handleSubmit(event: SubmitEvent) {
    event.preventDefault();
    if (
      personnelUpdateInfo().new_personnel_first_name === "" ||
      personnelUpdateInfo().new_personnel_last_name === ""
    ) {
      setErrorMessage(() => "Both First and Last names are required");
      return;
    }

    void fetchData(getUpdateStorePersonnelFetcher(personnelUpdateInfo()));
  }

  function handleNameChange(newValue: string, changeType: "first_name" | "last_name") {
    if (changeType === "first_name") {
      setPersonnelUpdateInfo((previousInfo) => {
        return { ...previousInfo, new_personnel_first_name: newValue.trim() };
      });
    } else {
      setPersonnelUpdateInfo((previousInfo) => {
        return { ...previousInfo, new_personnel_last_name: newValue.trim() };
      });
    }
  }

  return (
    <form onSubmit={handleSubmit} method="post" action={API_INFO.update_store_personnel} class="my-3">
      <legend class="form-label text-white w-100">Store Manager Info</legend>

      <label for="id-first-name-personnel" class="text-light">
        First Name
      </label>
      <input
        value={personnelUpdateInfo().new_personnel_first_name}
        onInput={(event) => handleNameChange(event.target.value, "first_name")}
        type="text"
        id="id-first-name-personnel"
        placeholder="First Name"
        class="form-control bg-dark text-white my-1"
        style={{ "border-color": "var(--bs-gray-600)" }}
      />

      <label for="id-last-name-personnel" class="text-light">
        Last Name
      </label>
      <input
        value={personnelUpdateInfo().new_personnel_last_name}
        onInput={(event) => handleNameChange(event.target.value, "last_name")}
        type="text"
        id="id-last-name-personnel"
        placeholder="Last Name"
        class="form-control bg-dark text-white my-1"
        style={{ "border-color": "var(--bs-gray-600)" }}
      />
      {errorMessage() !== null && <p class="mm-error-message">{errorMessage()}</p>}
      <button type="submit" class="text-center btn btn-primary my-1" disabled={isLoading()}>
        Submit Manager Info&nbsp;
        {isLoading() && <LoadingSpinner />}
      </button>
      {errorMessage() == null && !isLoading() && (fetchStatus().isError || fetchStatus().isSuccess) && (
        <FetchStatusMessage fetchStatus={fetchStatus} />
      )}
    </form>
  );
}
